import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { familiesAPI } from '../services/api';

const JoinFamilyPage = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      // User is already logged in, try to join the family
      const joinFamily = async () => {
        try {
          const response = await familiesAPI.joinByCode(code.toUpperCase());
          if (response.data && response.data.family_id) {
            // Successfully joined, redirect to family page
            navigate(`/families/${response.data.family_id}`);
          }
        } catch (err) {
          // If join fails, redirect to login with code
          navigate(`/login?code=${code.toUpperCase()}`);
        }
      };
      joinFamily();
    } else {
      // User is not logged in, redirect to login with code
      navigate(`/login?code=${code.toUpperCase()}`);
    }
  }, [code, isAuthenticated, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <p>Redirecting...</p>
    </div>
  );
};

export default JoinFamilyPage;
